// This patch must be imported first for React 19 compatibility with antd v5
import '@ant-design/v5-patch-for-react-19';

import { createRoot } from 'react-dom/client';
import { SnackbarProvider, closeSnackbar } from 'notistack';
import axios from 'axios';
import { Button } from '@mui/material';

// CSS imports
import './index.scss';
import './utils/main.scss';

// App component
import App from './App';

// Configure axios defaults
declare const __API_URL__: string;
axios.defaults.baseURL = __API_URL__;
axios.defaults.withCredentials = true;

const isUnderMaintenance = false;

const container = document.getElementById('root');
if (!container) {
  throw new Error('Root element not found');
}

const root = createRoot(container);

root.render(
  <SnackbarProvider
    anchorOrigin={{
      vertical: 'top',
      horizontal: 'right',
    }}
    autoHideDuration={10000}
    action={(snackbarId) => (
      <Button
        onClick={() => closeSnackbar(snackbarId)}
        sx={{ color: 'inherit' }}
      >
        Dismiss
      </Button>
    )}
  >
    {isUnderMaintenance ? (
      <h6 className="p-3">
        You have reached the registration page for AFT's Convention.
        This site is currently undergoing maintenance, and should
        be back online shortly.
      </h6>
    ) : (
      <App />
    )}
  </SnackbarProvider>
);
